// Images
// Types
import type { ImageProps } from 'next/image';

// Components
import SubStepOneForm from '@/components/pages/signup/userInfos/UserInfosForm/SubStepOneForm';
import SubStepThreeForm from '@/components/pages/signup/userInfos/UserInfosForm/SubStepThreeForm';
import SubStepTwoForm from '@/components/pages/signup/userInfos/UserInfosForm/SubStepTwoForm';

import user_infos_sub_step_1 from './../../../../public/images/signup/user_infos_sub_step_1.webp';
import user_infos_sub_step_2 from './../../../../public/images/signup/user_infos_sub_step_2.webp';
import user_infos_sub_step_3 from './../../../../public/images/signup/user_infos_sub_step_3.webp';

export type SubStepType = {
    id: number;
    title: string;
    subtitle: string;
    sideContentVisual: Pick<ImageProps, 'src' | 'width' | 'height'>;
    form: typeof SubStepOneForm | typeof SubStepTwoForm | typeof SubStepThreeForm;
    fields: string[];
};

export const subSteps: SubStepType[] = [
    {
        id: 1,
        title: 'user_infos.sub_step_1.title',
        subtitle: 'user_infos.sub_step_1.subtitle',
        sideContentVisual: {
            src: user_infos_sub_step_1,
            width: 431,
            height: 559
        },
        form: SubStepOneForm,
        fields: [
            'first_name',
            'last_name',
            'settings.timezone',
            'primary_goal',
            'hear_about_us',
            'hear_about_us_detail'
        ]
    },
    {
        id: 2,
        title: 'user_infos.sub_step_2.title',
        subtitle: 'user_infos.sub_step_2.subtitle',
        sideContentVisual: {
            src: user_infos_sub_step_2,
            width: 450,
            height: 553
        },
        form: SubStepTwoForm,
        fields: [
            'social_profiles_managed',
            'team_size',
            'social_media_tool',
            'social_media_tool_detail'
        ]
    },
    {
        id: 3,
        title: 'user_infos.sub_step_3.title',
        subtitle: 'user_infos.sub_step_3.subtitle',
        sideContentVisual: {
            src: user_infos_sub_step_3,
            width: 448,
            height: 553
        },
        form: SubStepThreeForm,
        fields: ['company', 'company_people_count', 'is_agency', 'is_agency_detail']
    }
];
